import { render, staticRenderFns } from "./UserInvitationsPage.vue?vue&type=template&id=21572ff4&"
import script from "./UserInvitationsPage.vue?vue&type=script&lang=js&"
export * from "./UserInvitationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports